'use strict';
const i18n = function (obj, field) {
    let lang = localStorage.getItem('lang');
    if(lang === 'en'){
        return obj[field + '_ENG'];
    }else if (lang === 'ru'){
        return obj[field + '_RUS'];
    }else {
        return obj[field];
    }
};

export default i18n;
